import { Grid } from '@mui/material';
import { IListItem } from '../listItem/IListItem';


export default function SqureCard({
    status,
    title,
    id,
    icon,
    onClick,
    borderColor,
    color,
}: IListItem) {
    return (
        <>
            <Grid
                style={{
                    border: '1.5px solid var(--border-color)',
                    height: '150px',
                    borderRadius: '5px',
                    background: 'var(--input-bg-color)',
                    alignContent: 'center',
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
                }}
                sx={{ flex: '1 1 calc(50% - 16px)' }}
                onClick={() => onClick!()}
            >
                <Grid container flexDirection={"column"} gap={"10px"} xs={12} justifyContent={"center"} alignItems={"center"}>
                    <Grid item>

                        {icon ? (
                            <div
                                style={{
                                    display: 'inline-block',
                                    alignSelf: 'center',
                                    background: "var(--bg-color)",
                                    color: "var(--tirnary-text-color)",
                                    padding: ".5rem",
                                    borderRadius: "50%",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.16)"
                                }}
                            >
                                {icon}
                            </div>
                        ) : null}
                    </Grid>
                    <Grid item>

                        <span style={{ fontSize: "14px", fontWeight: "bold" }} className={"text-sm " + (color != undefined ? color : "primaryColorLight-900")}>{title}</span>
                    </Grid>
                    <Grid item>       <span className="font-normal text-xs primaryColorLight-100" style={{ float: "right", fontSize: "10px" }}>
                        {status}
                    </span></Grid>
                </Grid>
            </Grid>
        </>
    );
}
